/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseLong } from '../models/api-response-long';
import { ApiResponseString } from '../models/api-response-string';
import { sendOtpSignUp } from '../fn/sign-up-api/send-otp-sign-up';
import { SendOtpSignUp$Params } from '../fn/sign-up-api/send-otp-sign-up';
import { signUp } from '../fn/sign-up-api/sign-up';
import { SignUp$Params } from '../fn/sign-up-api/sign-up';
import { verifyOtpSignUp } from '../fn/sign-up-api/verify-otp-sign-up';
import { VerifyOtpSignUp$Params } from '../fn/sign-up-api/verify-otp-sign-up';

@Injectable({ providedIn: 'root' })
export class SignUpApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `signUp()` */
  static readonly SignUpPath = '/v1/api/ui/public/sign-up';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signUp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  signUp$Response(params: SignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
    return signUp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `signUp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  signUp(params: SignUp$Params, context?: HttpContext): Observable<ApiResponseString> {
    return this.signUp$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseString>): ApiResponseString => r.body)
    );
  }

  /** Path part for operation `verifyOtpSignUp()` */
  static readonly VerifyOtpSignUpPath = '/v1/api/ui/public/sign-up/otp/verify';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyOtpSignUp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyOtpSignUp$Response(params: VerifyOtpSignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLong>> {
    return verifyOtpSignUp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyOtpSignUp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyOtpSignUp(params: VerifyOtpSignUp$Params, context?: HttpContext): Observable<ApiResponseLong> {
    return this.verifyOtpSignUp$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseLong>): ApiResponseLong => r.body)
    );
  }

  /** Path part for operation `sendOtpSignUp()` */
  static readonly SendOtpSignUpPath = '/v1/api/ui/public/sign-up/otp/send';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendOtpSignUp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendOtpSignUp$Response(params: SendOtpSignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLong>> {
    return sendOtpSignUp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendOtpSignUp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendOtpSignUp(params: SendOtpSignUp$Params, context?: HttpContext): Observable<ApiResponseLong> {
    return this.sendOtpSignUp$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseLong>): ApiResponseLong => r.body)
    );
  }

}
